import React, { useEffect, useState } from 'react';
import type { Partner } from '../../../types/partners';
import { PartnerLogo } from '../PartnerLogo';
import { TryPlatformButton } from '../TryPlatformButton';
import { UpvoteButton } from '../UpvoteButton';
import { PARTNER_BUTTON_CLASS } from './PartnerProfileHero';
import { cn } from '../../../src/lib/utils';

/** Conversion bar that appears once the profile hero has scrolled out of view. */
export function PartnerStickyCta({
  partner
}: {
  partner: Partner;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('partner-hero');
    if (!hero || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), {
      threshold: 0
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);
  return <div aria-hidden={!visible} className={cn('fixed inset-x-0 bottom-0 z-30 border-t border-hairline bg-ink/90 backdrop-blur-xl transition-[transform,visibility] duration-300 motion-reduce:transition-none', visible ? 'visible translate-y-0' : 'invisible translate-y-full')} data-id="element-721" data-mp="1j9h30pwe4ovz">
      <div className="mx-auto flex w-full max-w-[1320px] items-center justify-between gap-4 px-4 pb-[calc(env(safe-area-inset-bottom)+10px)] pt-2.5 sm:px-6 lg:px-8" data-id="element-722" data-mp="z500yynlacsp">
        <div className="hidden min-w-0 items-center gap-4 sm:flex" data-id="element-723" data-mp="u7zwutaavk48">
          <PartnerLogo partner={partner} className="h-6" data-id="element-724" data-mp="6gkwh6233cvm" />
          <p className="hidden truncate text-sm text-text-secondary md:block" data-id="element-725" data-mp="2ezitihq6ukd">{partner.tagline}</p>
        </div>
        <div className="flex w-full items-center gap-2 sm:w-auto" data-id="element-726" data-mp="gfa6kcnqnt1b">
          <UpvoteButton partner={partner} placement="profile_sticky" variant="inline" className="shrink-0" data-id="element-727" data-mp="bffg2a7vl5gs" />
          <TryPlatformButton partner={partner} placement="profile_sticky" label={partner.tryLabel} className={cn('flex-1 sm:flex-none', PARTNER_BUTTON_CLASS)} data-id="element-728" data-mp="1rsw6msv4zf1m" />
        </div>
      </div>
    </div>;
}